(function () {
  function initAboutPage(section) {
    if (section.getAttribute('data-animate') !== 'true') return;

    var items = section.querySelectorAll('[data-ap-animate]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      return; // no ap-js class added, content stays visible via CSS default
    }

    section.classList.add('ap-js');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, index) {
          if (entry.isIntersecting) {
            setTimeout(function () {
              entry.target.classList.add('is-inview');
            }, index * 80);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach(function (item) { observer.observe(item); });

    // Safety net: if anything is somehow never observed as intersecting
    // (e.g. very short viewport edge cases), reveal everything after a timeout.
    setTimeout(function () {
      items.forEach(function (item) { item.classList.add('is-inview'); });
    }, 4000);
  }

  function initAll() {
    document.querySelectorAll('.section-about-page').forEach(initAboutPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-about-page');
    if (section) initAboutPage(section);
  });
})();